import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/hubspot")({
  beforeLoad: () => {
    throw redirect({
      to: "/admin",
      search: { section: "hubspot" },
    });
  },
});
